import IApplication from "@/interfaces/ApplicationInterface";

const DEFAULT_APP_CONFIG: IApplication = {
  "tenantID": "",
  "intClientID": 0,
  "companyName": "Connection Error. Try Refreshing.",
  "appEnvironment": "Production",
  "intAppEnvironmentId": 5,
  "instrumentationKey": "",
  "urlProjectApollo": "https://apollo.snapsuite.io",
  "urlProjectEarth": "https://earth.snapsuite.io",
  "urlProjectMars": "https://app.snapsuite.io",
  "urlProjectMercury": "https://app.projectmercury.snapsuite.io",
  "urlProjectMarsDashboard": "https://dashboard.snapsuite.io/#/",
  "urlProjectCave": "https://cave.snapsuite.io",
  "urlProjectJupiter": "https://jupiter.snapsuite.io",
  "urlDocuments": "https://docs.snapsuite.io",
  "urlDocumentGeneratorWCF": "https://wcf-central.azurewebsites.net/Word2PDFConverter.svc",
  "urlWebsite": "",
  "appProfileSettingsSMSAccountSID": "AC9367e857e2344fe3afc76084303c3c6e",
  "appProfileSettingsSMSAuthorizationToken": "92ab6ca80c163fa59bdd2dacb50987d3",
  "appProfileSettingsStatusCallback": "https://earth.snapsuite.io/Views/_public/sms/callbacksms.aspx?t=d2310bab-ffe5-4c5e-85ec-06c651749e03",
  "appProfileSettingsStorageAccount": "",
  "appProfileSettingsStorageAccessKey": "",
  "appProfileSettingsStorageContainerName": "Production",
  "appProfileSettingsStorageContainerLocation": "ss-p",
  "appProfileSettingsSmtphost": "",
  "appProfileSettingsSMTPOutgoingEmail": "",
  "appProfileSettingsSmtpport": "",
  "appProfileSettingsSMTPPassword": "smtp",
  "appProfileSettingsSmtpenableSsl": "",
  "appProfileSettingsSendViaAuthSmtp": "",
  "databaseConnectionStringDataSource": "",
  "databaseConnectionStringInitialCatalog": "",
  "databaseConnectionStringUserId": "",
  "databaseConnectionStringPassword": "",
  "enableHttpsProtocol": true,
  "timeZone": "Eastern Standard Time",
  "taxRate": 0.13,
  "sequenceStartNumberQuote": 5000,
  "sequenceStartNumberProject": 5006,
  "sequenceStartNumberPurchaseOrder": 50000,
  "sequenceStartNumberInvoice": 5000,
  "referenceNumberQuotePrefix": "Q         ",
  "referenceNumberProjectPrefix": "W         ",
  "referenceNumberPurchaseOrderPrefix": "PO        ",
  "referenceNumberInvoicePrefix": "I         ",
  "intPackageID": 0,
  "firstName": "Helene",
  "email": "helene@divimechanical.com",
  "street": "Unit 9, 178 Pennsylvania Avenue, ,  ",
  "employees": 0,
  "yearEndDate": "2020-04-01T00:00:00",
  "defaultIntLanguageID": 0,
  "intIndustryID": 0,
  "isDefault": false,
  "utcCreatedDate": "2024-11-20T19:40:32",
  "utcModifiedDate": "2024-11-20T19:40:32",
  "officialStartDate": "0001-01-01T00:00:00",
  "isSystem": true,
  "sort": 0,
  "isExportToThirdPartyApplication": false,
  "address": "Unit 9, 178 Pennsylvania Avenue, ,  , , , ",
  // Adding the missing property required by the interface
  "supportUrl": ""
} as IApplication;

export default DEFAULT_APP_CONFIG;